import { render, staticRenderFns } from "./defaultList.vue?vue&type=template&id=f14d71f2&scoped=true&"
import script from "./defaultList.vue?vue&type=script&lang=js&"
export * from "./defaultList.vue?vue&type=script&lang=js&"
import style0 from "./defaultList.vue?vue&type=style&index=0&id=f14d71f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14d71f2",
  null
  
)

export default component.exports